module.exports = __webpack_public_path__ + "static/media/btn_point_front_nor.37e38cc5.svg";